import { render, staticRenderFns } from "./custom-form-common-area.vue?vue&type=template&id=14580b84&"
import script from "./custom-form-common-area.vue?vue&type=script&lang=js&"
export * from "./custom-form-common-area.vue?vue&type=script&lang=js&"
import style0 from "./custom-form-common-area.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports